import Component from '../core/Component'

export default class ProductCardKrytina extends Component {
    constructor(element, options = {}) {
        super(element, options)

        this.ref = {
            productImage: null,
            colors: [],
            imagesBuffer: null
        }

        this.imagesBuffer = null
    }

    prepare() {
        this.element.addEventListener('mouseover', this.handleMouseLeave)
        this.element.addEventListener('mouseover', this.handleMouseOver)
    }

    destroy() {
        this.element.removeEventListener('mouseleave', this.handleMouseLeave)
        this.element.removeEventListener('mouseover', this.handleMouseOver)
    }

    handleMouseOver = () => {
        this.attach()
    }

    handleMouseLeave = () => {
        this.detach()
    }

    handleColorMouseEnter = event => {
        const color = event.target.dataset.color
        if (!color) {
            return
        }

        const imgByColor = this.imagesBuffer.querySelector(`[data-color="${color}"]`)
        if (!imgByColor) {
            return
        }
        this.ref.productImage.innerHTML = imgByColor.innerHTML
    }

    attach() {
        if (this.isAttached) {
            return
        }
        this.imagesBuffer = document.createElement('div')
        this.imagesBuffer.innerHTML = this.ref.imagesBuffer.innerHTML
        this.ref.colors.forEach(color => color.addEventListener('mouseenter', this.handleColorMouseEnter))
        this.isAttached = true
    }

    detach() {
        if (!this.isAttached) {
            return
        }
        this.imagesBuffer = null
        this.ref.colors.forEach(color => color.removeEventListener('mouseenter', this.handleColorMouseEnter))
        this.isAttached = false
    }

}